/* eslint-disable no-useless-computed-key */
import React, { useState, useEffect, ChangeEvent } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
  Grid,
  Paper,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import "dayjs/locale/es";
import { budget } from "../../api/budget";
import { useNotification } from "../../context/notification.context";
import dayjs from 'dayjs'; 


type ModalProductProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onCancel: () => void;
  title: string; 
  initialData?: any | null;
  providerId?: number;
  files?: any | null;
  isFromPaymentList?: boolean;
  providersList?: any;
};

export const ModalProductComponent: React.FC<ModalProductProps> = ({
  open,
  onClose,
  onSave,
  onCancel,
  title,
  initialData,
  providerId,
  files,
  isFromPaymentList = false,
  providersList
}) => {
  const [formData, setFormData] = useState<any>({});
  const { getError, getSuccess } = useNotification();

  useEffect(() => {     
    if (initialData) {    
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | { name: string; value: unknown }> | SelectChangeEvent<any>,
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {    
    try {
        console.log("providerId recibido:", providerId);
        
        if (!providerId) {
          getError("Error: No se proporcionó el ID del proveedor");
          return;
        }
        
        const productData = {
          proveedorId: providerId,
          fecha: (formData["fecha"]) ? formData["fecha"] : new Date(),
          cliente: formData["cliente"],
          tipo: formData["tipo"],
          file: formData["file"],
          moneda: formData[`moneda`] || "$",
          importe: formData["importe"],
          concepto: formData["concepto"],
          descripcion: formData["descripcion"],
        };
        console.log("Datos del producto a enviar:", productData);
        await budget.create(productData);
        getSuccess("Producto agregado correctamente");   
        handleClose();        
    } catch (error) {
      getError("Error al agregar el producto: " + error);
    }
  };

  const handleUpdate = async () => {    
    try {        
        const productData = {
          proveedorId: providerId,
          productoId: initialData.producto,
          fecha: (formData["fecha"]) ? formData["fecha"] : new Date(),
          cliente: formData["cliente"],
          tipo: formData["tipo"],
          file: formData["file"],
          moneda: formData[`moneda`] || "$",
          importe: formData["importe"],
          concepto: formData["concepto"],
          descripcion: formData["descripcion"],
        };
        const id = initialData.id.split("_")[1];
        await budget.update(id, productData);
        getSuccess("Producto editado correctamente");   
        handleClose();        
    } catch (error) {
      getError("Error al agregar el pago: " + error);
    }
  };

  const handleClose = () => {  
    setFormData({});
    onClose();
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
      <Grid container sx={{ mt: 2 }}>  
          <Grid item xs={4} sx={{ pr: 2 }}>
            <InputLabel sx={{ mt: 1 }}>
              Fecha de Viaje
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker        
                  format="DD/MM/YYYY"                  
                  onChange={(value) => {
                    setFormData((prevData: any) => ({
                      ...prevData,
                      [`fecha`]: dayjs(value),
                    }));
                  }}
                  value={dayjs(formData[`fecha`])}
              />              
            </LocalizationProvider>
          </Grid>
          <Grid item xs={8}>
            <InputLabel sx={{ mt: 1 }}>
              Cliente
            </InputLabel>
            <TextField
              key={"cliente"}              
              name={"cliente"}
              fullWidth
              sx={{ mt: 0 }}
              onChange={handleChange}
              value={formData[`cliente`]}
            />
          </Grid>        
        </Grid>
        <Grid container sx={{ mt: 2 }}>  
          <Grid item xs={4} sx={{ pr: 2 }}>
            <InputLabel sx={{ mt: 1 }}>
              Tipo de Producto
            </InputLabel>
            <Select
              key={`tipo`}
              label={`tipo-label`}
              id={`tipo`}
              name={`tipo`}
              value={formData[`tipo`] || "Aereo"}
              onChange={handleChange} 
              fullWidth
              disabled={(formData[`tipo`]) ? true : false}
            >
              <MenuItem key={"Aéreo"} value={"Aéreo"}>
                {"Aéreo"}
              </MenuItem>
              <MenuItem key={"Alojamiento"} value={"Alojamiento"}>
                {"Alojamiento"}
              </MenuItem>
              <MenuItem key={"Servicio"} value={"Servicio"}>
                {"Servicio"}
              </MenuItem>
            </Select>             
          </Grid>
          <Grid item xs={8}>
            <InputLabel sx={{ mt: 1 }}>
              File
            </InputLabel>
            <TextField
              key={"file"}              
              name={"file"}
              fullWidth
              sx={{ mt: 0 }}
              onChange={handleChange}
              value={formData[`file`]}
            />
          </Grid>        
        </Grid>
        <Grid container sx={{ mt: 2 }}>  
          <Grid item xs={4} sx={{ pr: 2 }}>
            <InputLabel sx={{ mt: 1 }}>
              Moneda
            </InputLabel>
            <Select
              key={`moneda`}
              label={`moneda-label`}
              id={`moneda`}
              name={`moneda`}
              value={formData[`moneda`] || "$"}
              onChange={handleChange} 
              fullWidth
            >
              <MenuItem key={"$"} value={"$"} selected={true}>
                {"$"}
              </MenuItem>
              <MenuItem key={"U$S"} value={"U$S"}>
                {"U$S"}
              </MenuItem>
            </Select>             
          </Grid>
          <Grid item xs={8}>
            <InputLabel sx={{ mt: 1 }}>
              Importe $
            </InputLabel>
            <TextField
              key={"importe"}              
              name={"importe"}
              fullWidth
              sx={{ mt: 0 }}
              type={"number"}
              onChange={handleChange}
              value={formData[`importe`]}
            />
          </Grid>        
        </Grid>
        <Grid container sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12}>
            <InputLabel sx={{ mt: 1 }}>
              Concepto
            </InputLabel>
            <TextField
              key={"concepto"}              
              name={"concepto"}
              fullWidth
              sx={{ mt: 0 }}
              onChange={handleChange}
              value={formData[`concepto`]}
            />
          </Grid>
        </Grid>   
        <Grid container sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12}>
            <InputLabel sx={{ mt: 1 }}>
              Descripción
            </InputLabel>
            <TextField
              key={"descripcion"}              
              name={"descripcion"}
              multiline={true}
              rows={4}
              fullWidth
              sx={{ mt: 0 }}
              onChange={handleChange}
              value={formData[`descripcion`]}
            />
          </Grid>
        </Grid>   
        <Paper variant="outlined" />
      </DialogContent>      
      <DialogActions>
        <Button onClick={handleClose} style={{backgroundColor:"#ed3c3cde", color:"#000000"}}>Cancelar</Button>
        <Button onClick={initialData && Object.keys(initialData).length > 0 ? () => {handleUpdate();} : () => {handleSave();}} style={{backgroundColor:"#6da34cde", color:"#000000"}}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};
